import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-01e5b5cc"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "background-color": "#f5f5f5"
  }
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "nav_article"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "height": "2rem"
    }
  }, null, -1);
});

var _hoisted_8 = {
  class: "copyright"
};
var _hoisted_9 = {
  key: 0
};
var _hoisted_10 = {
  key: 1
};
var _hoisted_11 = {
  key: 2
};
var _hoisted_12 = {
  key: 3
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "联系电话：0571-28888520", -1);
});

var _hoisted_14 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  key: 1
};
var _hoisted_17 = {
  key: 2
};
var _hoisted_18 = {
  key: 3
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_swipe_item = _resolveComponent("van-swipe-item");

  var _component_van_swipe = _resolveComponent("van-swipe");

  var _component_van_image = _resolveComponent("van-image");

  var _component_van_col = _resolveComponent("van-col");

  var _component_van_row = _resolveComponent("van-row");

  var _component_Product = _resolveComponent("Product");

  var _component_Broadband = _resolveComponent("Broadband");

  var _component_Customize = _resolveComponent("Customize");

  var _component_QueryOrder = _resolveComponent("QueryOrder");

  var _component_AboutUs = _resolveComponent("AboutUs");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_swipe, {
    autoplay: 3000,
    "lazy-render": ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_swipe_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('@/assets/images/main.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_2)];
        }),
        _: 1
      }), $data.fullPath.indexOf('52haoma.com') != -1 ? (_openBlock(), _createBlock(_component_van_swipe_item, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('@/assets/images/telcom_bsp.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_3)];
        }),
        _: 1
      })) : _createCommentVNode("", true), $data.fullPath.indexOf('52haoma.com') != -1 ? (_openBlock(), _createBlock(_component_van_swipe_item, {
        key: 1
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('@/assets/images/broadnet_bsp.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_4)];
        }),
        _: 1
      })) : _createCommentVNode("", true), $data.fullPath.indexOf('52haoma.com') != -1 ? (_openBlock(), _createBlock(_component_van_swipe_item, {
        key: 2
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("img", {
            src: require('@/assets/images/changsha_jd_unicom_bsp.png'),
            style: {
              "width": "7.5rem"
            }
          }, null, 8, _hoisted_5)];
        }),
        _: 1
      })) : _createCommentVNode("", true)];
    }),
    _: 1
  }), _createVNode(_component_van_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_col, {
        span: "24"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("article", _hoisted_6, [_createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $data.tabIndex = 2;
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/broadband.png')
          }, null, 8, ["src"]), _createElementVNode("span", {
            class: _normalizeClass($data.tabIndex == 2 ? 'selected' : '')
          }, "装宽带", 2)]), _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return $data.tabIndex = 4;
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/query_order.png')
          }, null, 8, ["src"]), _createElementVNode("span", {
            class: _normalizeClass($data.tabIndex == 4 ? 'selected' : '')
          }, "查订单", 2)]), $data.fullPath.indexOf('www.xiaotel.com') == -1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return $data.tabIndex = 5;
            })
          }, [_createVNode(_component_van_image, {
            src: require('../assets/images/about_us.png')
          }, null, 8, ["src"]), _createElementVNode("span", {
            class: _normalizeClass($data.tabIndex == 5 ? 'selected' : '')
          }, "关于我们", 2)])) : _createCommentVNode("", true)])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), $data.tabIndex == 1 ? (_openBlock(), _createBlock(_component_Product, {
    key: 0
  })) : $data.tabIndex == 2 ? (_openBlock(), _createBlock(_component_Broadband, {
    key: 1
  })) : $data.tabIndex == 3 ? (_openBlock(), _createBlock(_component_Customize, {
    key: 2
  })) : $data.tabIndex == 4 ? (_openBlock(), _createBlock(_component_QueryOrder, {
    key: 3
  })) : $data.tabIndex == 5 ? (_openBlock(), _createBlock(_component_AboutUs, {
    key: 4
  })) : _createCommentVNode("", true), _hoisted_7, _createElementVNode("div", _hoisted_8, [$data.fullPath.indexOf('xiaotel.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "版权所有：杭州估的好科技有限公司")) : $data.fullPath.indexOf('52tongxun.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "版权所有：杭州百亿通讯有限公司")) : $data.fullPath.indexOf('52taocan.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "版权所有：杭州彩轩科技有限公司")) : (_openBlock(), _createElementBlock("span", _hoisted_12, "版权所有：杭州我爱号码网电子商务有限公司")), _hoisted_13, _createElementVNode("span", null, [_createElementVNode("a", _hoisted_14, [$data.fullPath.indexOf('52tongxun.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, "浙ICP备2026029167号-1")) : $data.fullPath.indexOf('52taocan.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "浙ICP备19034816号-7")) : $data.fullPath.indexOf('xiaotel.com') != -1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, "浙ICP备2023036698号-1")) : (_openBlock(), _createElementBlock("span", _hoisted_18, "浙ICP备19034816号-1"))])])])]);
}